module.exports = __webpack_public_path__ + "img/5ac_28.f5ad98d4.gif";